const navStart = (() => {
  if (typeof performance === 'undefined') return 0;
  const nav = performance.getEntriesByType('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined;
  if (nav) return nav.startTime;
  return 0;
})();

let firstDotLogged = false;

export function markFirstDot(): void {
  if (firstDotLogged || typeof performance === 'undefined') return;
  firstDotLogged = true;
  const elapsedMs = performance.now() - navStart;
  const seconds = (elapsedMs / 1000).toFixed(2);
  // eslint-disable-next-line no-console
  console.info(`[perf] time-to-first-dot: ${seconds}s (${elapsedMs.toFixed(0)} ms)`);
}
